const PUBLIC_EXACT_PATHS = new Set(['/login', '/recover', '/forgot-password', '/forgot-password-reset', '/auth/complete']);

function withoutLocalePrefix(path: string, locales: readonly string[]): string {
	const firstSegment = path.split('/')[1];
	return locales.includes(firstSegment) ? path.slice(firstSegment.length + 1) || '/' : path;
}

/** Public routes are explicit; everything else requires a live session. */
export function isPublicRoute(url: string, locales: readonly string[] = []): boolean {
	const path = withoutLocalePrefix(url.split(/[?#]/)[0], locales);
	const isPublicForm = /^\/workspaces\/[^/]+\/forms\/public(?:\/|$)/.test(path);
	const isApproval = path === '/approve' || path.startsWith('/approve/');
	return PUBLIC_EXACT_PATHS.has(path) || isPublicForm || isApproval;
}
